var PageTypeEnum = /* @__PURE__ */ ((PageTypeEnum2) => {
  PageTypeEnum2["HOME"] = "PAGE_TYPE_HOME";
  PageTypeEnum2["CATEGORY"] = "PAGE_TYPE_CATEGORY";
  PageTypeEnum2["NOTIFICATION"] = "PAGE_TYPE_NOTIFICATION";
  PageTypeEnum2["SELLER"] = "PAGE_TYPE_SELLER";
  PageTypeEnum2["BRAND"] = "PAGE_TYPE_BRAND";
  return PageTypeEnum2;
})(PageTypeEnum || {});
var BlockItemType = /* @__PURE__ */ ((BlockItemType2) => {
  BlockItemType2["BANNER"] = "BANNER";
  BlockItemType2["MENU"] = "MENU";
  BlockItemType2["SKU"] = "SKU";
  BlockItemType2["LOCAL"] = "LOCAL";
  return BlockItemType2;
})(BlockItemType || {});
var BlockType = /* @__PURE__ */ ((BlockType2) => {
  BlockType2["SLIDE_BANNER"] = "SLIDE_BANNER";
  BlockType2["WIDE_THIN_BANNER"] = "WIDE_THIN_BANNER";
  BlockType2["WIDE_THICK_BANNER"] = "WIDE_THICK_BANNER";
  BlockType2["VERTICAL_2_BANNER"] = "VERTICAL_2_BANNER";
  BlockType2["HORIZONTAL_4_BANNER"] = "HORIZONTAL_4_BANNER";
  BlockType2["HORIZONTAL_BODY_BANNER"] = "HORIZONTAL_BODY_BANNER";
  BlockType2["HORIZONTAL_BODY_2_BANNER"] = "HORIZONTAL_BODY_2_BANNER";
  BlockType2["HORIZONTAL_BODY_3_BANNER"] = "HORIZONTAL_BODY_3_BANNER";
  BlockType2["HORIZONTAL_2_BANNER_MOBILE"] = "HORIZONTAL_2_BANNER_MOBILE";
  BlockType2["POPUP_BANNER"] = "POPUP_BANNER";
  BlockType2["POPUP_BANNER_MOBILE"] = "POPUP_BANNER_MOBILE";
  BlockType2["LEFT_STICKY_BANNER"] = "LEFT_STICKY_BANNER";
  BlockType2["RIGHT_STICKY_BANNER"] = "RIGHT_STICKY_BANNER";
  BlockType2["PROMOTE_CATEGORY_MENU"] = "PROMOTE_CATEGORY_MENU";
  BlockType2["RECOMMENDED_BRANDS"] = "RECOMMENDED_BRANDS";
  BlockType2["RECOMMENDED_CATEGORY"] = "RECOMMENDED_CATEGORY";
  BlockType2["LISTING_TAB"] = "LISTING_TAB";
  BlockType2["HORIZONTAL_HIGHLIGHTED_BANNER"] = "HORIZONTAL_HIGHLIGHTED_BANNER";
  BlockType2["COUNT_DOWN_PROMO_BIG_SKU"] = "COUNT_DOWN_PROMO_BIG_SKU";
  BlockType2["COUNT_DOWN_PROMO_TAB_MOBILE"] = "COUNT_DOWN_PROMO_TAB_MOBILE";
  BlockType2["MIX_BANNER"] = "MIX_BANNER";
  BlockType2["MEDIUM_ICON_MENU_MOBILE"] = "MEDIUM_ICON_MENU_MOBILE";
  BlockType2["NAVIGATION_BAR"] = "NAVIGATION_BAR";
  BlockType2["PROMOTE_SELLER"] = "PROMOTE_SELLER";
  BlockType2["BEST_SELLING_PRODUCT"] = "BEST_SELLING_PRODUCT";
  BlockType2["FLASH_SALE"] = "FLASH_SALE";
  BlockType2["COUNT_DOWN_PROMO_SKU"] = "COUNT_DOWN_PROMO_SKU";
  BlockType2["HORIZONTAL_SKU_LIST"] = "HORIZONTAL_SKU_LIST";
  BlockType2["MAIN_SKU_LIST"] = "MAIN_SKU_LIST";
  BlockType2["LIST_SKU_MOBILE"] = "LIST_SKU_MOBILE";
  BlockType2["POS365_LIST_SKU"] = "POS365_LIST_SKU";
  BlockType2["PRODUCT_LINE_MENU"] = "PRODUCT_LINE_MENU";
  BlockType2["LOCATION"] = "LOCATION";
  BlockType2["PENDING_PAYMENT"] = "PENDING_PAYMENT";
  BlockType2["LEFT_OFF_ITEMS"] = "LEFT_OFF_ITEMS";
  BlockType2["RECENT_PRODUCT"] = "RECENT_PRODUCT";
  BlockType2["RECENT_SEARCH"] = "RECENT_SEARCH";
  BlockType2["MEGA_MENU"] = "MEGA_MENU";
  BlockType2["YOUTUBE"] = "YOUTUBE";
  BlockType2["PERSONALIZATION_PLACEHOLDER"] = "PERSONALIZATION_PLACEHOLDER";
  BlockType2["SMALL_MIX_NEWS"] = "SMALL_MIX_NEWS";
  return BlockType2;
})(BlockType || {});

export { BlockItemType, BlockType, PageTypeEnum };
